// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_febfbb', '__Roboto_Fallback_febfbb'","fontWeight":300,"fontStyle":"normal"},"className":"__className_febfbb"};